import { useEffect, useRef } from 'react';
import { create } from 'zustand';
let nextEventId = 0;
const useConnectorCatalogStore = create((set) => ({
    lastEvent: null,
    emit: (args) => set({ lastEvent: { ...args, id: ++nextEventId } }),
}));
export const emitConnectorCatalogChanged = (args) => useConnectorCatalogStore.getState().emit(args);
export const useOnConnectorCatalogChanged = (callback) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    useEffect(() => {
        return useConnectorCatalogStore.subscribe((state, prevState) => {
            if (state.lastEvent === prevState.lastEvent || !state.lastEvent)
                return;
            callbackRef.current(state.lastEvent);
        });
    }, []);
};
//# sourceMappingURL=connectorCatalogEvents.js.map